import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Card } from "@/components/erp/ui";
import { Hourglass } from "lucide-react";

const hm = (m) => `${Math.floor((m || 0) / 60)} jam ${(m || 0) % 60} menit`;

// Sisa hutang jam (alfa) karyawan yang login untuk periode gaji berjalan
export const HourDebtCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/discipline/my-debt").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d?.employee || (!d.hour_debt_min && !d.early_min)) return null;
  const lunas = d.debt_left_min <= 0 && d.early_left_min <= 0;
  return (
    <Card className={`p-4 mb-5 ${lunas ? "border-emerald-300" : "border-rose-300"}`} data-testid="hour-debt-card">
      <div className="flex items-start gap-3">
        <Hourglass className={`w-5 h-5 mt-0.5 ${lunas ? "text-emerald-600" : "text-rose-600"}`} />
        <div className="text-sm">
          <div className="font-semibold" data-testid="hour-debt-left">{lunas ? "Hutang jam sudah lunas" : `Sisa hutang jam: ${hm(d.debt_left_min + d.early_left_min)}`}</div>
          <div className="text-xs text-slate-500 mt-0.5">Periode gaji {d.start} s/d {d.end} · alfa {d.alfa_days} hari = {hm(d.hour_debt_min)} · pulang awal {d.early_days} hari = {hm(d.early_min)}</div>
          {d.debt_left_min > 0 && <div className="text-xs text-rose-600 mt-1" data-testid="hour-debt-estimate">Alfa: lembur (disetujui) {hm(d.debt_left_min)} sebelum {d.end}. Kalau tidak, uang harian / gaji terpotong sekitar {formatIDR(d.deduct_estimate)}.</div>}
          {d.early_left_min > 0 && <div className="text-xs text-rose-600 mt-1" data-testid="hour-debt-early">Pulang awal: lembur {hm(d.early_left_min)} sebelum {d.end}. Kalau tidak, dipotong {formatIDR(d.early_deduct_estimate)} dan nilai kinerja berkurang.</div>}
        </div>
      </div>
    </Card>
  );
};
